import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { IconComponent } from '@claas/claas-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { HasPermissionsDirective } from '@cde-fe-app/app/shared/directive/hasPermissions.directive';
import { EventTrackingService } from '@cde-fe-app/app/shared/services/event-tracking.service';
import { AppLauncherFastAccessEntryComponent } from '../app-launcher-fast-access-entry/app-launcher-fast-access-entry.component';
import { IAppLauncherAppDescription } from '../app-launcher.source';

@Component({
  selector: 'app-app-launcher-app-tile',
  templateUrl: './app-launcher-app-tile.component.html',
  styleUrls: ['./app-launcher-app-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HasPermissionsDirective, TranslateModule, AppLauncherFastAccessEntryComponent, IconComponent],
})
export class AppLauncherAppTileComponent {
  readonly eventTrackingService = inject(EventTrackingService);
  @Input() appDescription: IAppLauncherAppDescription;

  openApp() {
    if (this.appDescription.trackEventNew != null) {
      this.eventTrackingService.eventTrackNew({ payload: this.appDescription.trackEventNew });
    }

    if (this.appDescription.target) {
      window.open(this.appDescription.link, this.appDescription.target);
    } else {
      window.location.replace(this.appDescription.link);
    }
  }
}
